import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var Redirect = _ref => {
  var {
    url
  } = _ref;
  var router = useRouter();
  useEffect(() => {
    if (url) router.push(url);
  }, [router, url]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};
//# sourceMappingURL=redirect.js.map